import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    museumList: [],
};
const getters = {
    getMuseum: state => state.museumList

};

const mutations = {
    MUSEUM_INFO(state, data) {
        state.museumList = data
    }
};

const actions = {
    getMuseum({commit}) {
        axiosGet(`crm/museum/list`).then((response) => {
            commit('MUSEUM_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
